import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-small-top',
  templateUrl: './ticket-graphic-small-top.component.html',
  styleUrls: ['./ticket-graphic-small-top.component.scss'],
})
export class TicketGraphicSmallTopComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
